// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface HandlerOperationAbortRequest
 */
export interface HandlerOperationAbortRequest {
  /**
   *
   * @type {string}
   * @memberof HandlerOperationAbortRequest
   */
  id: string;
}

/**
 * Check if a given object implements the HandlerOperationAbortRequest interface.
 */
export function instanceOfHandlerOperationAbortRequest(
  value: object,
): value is HandlerOperationAbortRequest {
  if (!('id' in value) || value['id'] === undefined) return false;
  return true;
}

export function HandlerOperationAbortRequestFromJSON(
  json: any,
): HandlerOperationAbortRequest {
  return HandlerOperationAbortRequestFromJSONTyped(json, false);
}

export function HandlerOperationAbortRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerOperationAbortRequest {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
  };
}

export function HandlerOperationAbortRequestToJSON(
  json: any,
): HandlerOperationAbortRequest {
  return HandlerOperationAbortRequestToJSONTyped(json, false);
}

export function HandlerOperationAbortRequestToJSONTyped(
  value?: HandlerOperationAbortRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
  };
}
